import { useEffect, RefObject } from 'react';

interface ClickOutsideHookParams {
  ref: RefObject<any>;
  setToggle: React.Dispatch<React.SetStateAction<boolean | any>>;
  type?: 'boolean' | 'string';
}

export const useClickOutside = ({
  ref,
  setToggle,
  type = 'boolean',
}: ClickOutsideHookParams) => {
  useEffect(() => {
    const checkIfClickedOutside = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setToggle(type === 'string' ? '' : false);
      }
    };

    document.addEventListener('mousedown', checkIfClickedOutside);
    return () => {
      document.removeEventListener('mousedown', checkIfClickedOutside);
    };
  }, [ref, setToggle, type]);
};
